import { useEffect } from 'react';
import useTranslate from './useTranslate';
import type { IStateController } from '../lib/widget/state/state.interface';
import { useInjection } from 'inversify-react';
import { STATE_MODULE_IDS } from '../lib/widget/state/state.types';
import type { ITicketsController } from '../lib/widget/tickets/tickets.interface';
import { TICKETS_MODULE_IDS } from '../lib/widget/tickets/tickets.types';

let timeout: any;

const useReloadOverlay = ({ toggle, reloadMinutes }) => {
  const ticketsController: ITicketsController = useInjection(TICKETS_MODULE_IDS.TICKETS_CONTROLLER);
  const stateController: IStateController = useInjection(STATE_MODULE_IDS.STATE_CONTROLLER);

  const { t } = useTranslate();

  const reload = () => {
    toggle(false);

    stateController.emit(stateController.events.RELOAD_TICKETS);

    ticketsController.reloadTickets();
  };
  const timeoutMinutes = reloadMinutes * 1000 * 60;

  timeout =
    timeout ||
    setTimeout(() => {
      if (window.Widget.schemaIsBroken) return;
      toggle(true);
    }, timeoutMinutes);

  const handleMouseMove = () => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      if (window.Widget.schemaIsBroken) return;
      toggle(true);
    }, timeoutMinutes);
  };

  useEffect(() => {
    addEventListener('mousemove', handleMouseMove);
    return () => removeEventListener('mousemove', handleMouseMove);
  }, []);

  return { t, reload };
};

export default useReloadOverlay;
